<div class="wrapper">
  <app-sample-records-list />
</div>
